export const frameCostPerQrCode = 20;

export const baseTemplates = [
  `Watercolor`,
  `Cyberpunk City`,
  `Ink Landscape`,
  `Interior Painting`,
  `Japanese Street`,
  `Mech`,
  `Minecraft`,
  `Picasso Painting`,
  `Game Map`,
  `Spaceship`,
  `Chinese Painting`,
  `Winter Village`,
] as const;

export const tool = "ai-qr-code-generator";
